/**
 * RISE SKIN CONCIERGE
 * Permanent Shopify Commerce Map
 *
 * Maps Concierge product IDs to exact Shopify product handles.
 *
 * IMPORTANT:
 * - Recommendation intelligence stays in rise-skin-products.js
 * - Commerce identity lives here
 * - ALL sellable products, including SkinBetter, use Shopify
 */

(function () {
  "use strict";

  window.RISE_SKIN = window.RISE_SKIN || {};

  // ============================================================
  // PERMANENT PRODUCT ID -> SHOPIFY HANDLE MAP
  // ============================================================

  const COMMERCE_MAP = {

    // ==========================================================
    // SKINBETTER SCIENCE
    // ==========================================================

    "skinbetter-alpharet-overnight-cream":
      "alpharet-overnight-cream",

    "skinbetter-intensive-alpharet-overnight-cream":
      "intensive-alpharet-overnight-cream",

    "skinbetter-eyemax-alpharet":
      "eyemax-alpharet-overnight-cream",

    "skinbetter-alpharet-clearing-serum":
      "alpharet-clearing-serum",

    "skinbetter-alto-advanced-defense-repair-serum":
      "alto-advanced-defense-repair-serum",

    "skinbetter-even-tone-correcting-serum":
      "even-tone-correcting-serum",

    "skinbetter-mystro-active-balance-serum":
      "mystro-active-balance-serum",

    "skinbetter-interfuse-treatment-cream-face-neck":
      "interfuse-treatment-face-neck",

    "skinbetter-interfuse-treatment-cream-eye":
      "interfuse-treatment-cream-eye",

    "skinbetter-trio-rebalancing-moisture-treatment":
      "trio-rebalancing-moisture-treatment",

    "skinbetter-trio-luxe-moisture-treatment":
      "trio-luxe-moisture-treatment",

    "skinbetter-hydration-boosting-cream":
      "hydration-boosting-cream",

    "skinbetter-cleansing-gel":
      "cleansing-gel",

    "refining-foam-cleanser":
      "refining-foam-cleanser",

    "skinbetter-techno-neck-perfecting-cream":
      "techno-neck-perfecting-cream",

    "skinbetter-instant-effect-gel-eye":
      "instant-effect-gel-eye",

    "skinbetter-interfuse-lines":
      "interfuse-intensive-treatment-lines",

    "skinbetter-solo-hydrating-defense-men":
      "solo-hydrating-defense-men",

    "skinbetter-detoxifying-scrub-mask":
      "detoxifying-scrub-mask",

    "skinbetter-alto-defense-serum":
      "alto-defense-serum",

    "skinbetter-even-intensive":
      "even-intensive-skin-tone-correcting-serum",

    "skinbetter-mystro-revive":
      "mystro-revive-renewing-serum",

    "skinbetter-alpharet-exfoliating-peel-pads":
      "alpharet-exfoliating-peel-pads",

    "skinbetter-sunbetter-sheer-spf-56-stick":
      "sunbetter-sheer-sunscreen-stick-spf-56",

    "skinbetter-sunbetter-tone-smart-spf-68-compact":
      "sunbetter-tone-smart-sunscreen-compact-spf-68",

    "skinbetter-sunbetter-tone-smart-spf-75-lotion":
      "sunbetter-tone-smart-sunscreen-spf-75",


    // ==========================================================
    // PLATED
    // ==========================================================

    "plated-intense":
      "plated-intense-serum",

    "plated-eye":
      "plated-eye-serum",


    // ==========================================================
    // HYDRINITY
    // ==========================================================

    "hydrinity-hyacyn-active":
      "hyacyn-active-spray",

    "hydrinity-restorative-ha-sheet-mask":
      "sheet-mask",


    // ==========================================================
    // ANFISA
    // ==========================================================

    "anfisa-an-dew":
      "an-dew-azelaic-acid-pha",

    "anfisa-an-balm":
      "radiant-hydra-balm",

    "anfisa-an-gloss":
      "anfisa-skin-an-gloss-ceramide-lip-treatment-gloss",


    // ==========================================================
    // ALASTIN
    // ==========================================================

    "alastin-hydratint-pro-mineral-spf-36":
      "hydratint-pro-mineral-broad-spectrum-spf-36",

    "alastin-ha-immerse-serum":
      "ha-immerse-serum",

    "alastin-restorative-skin-complex":
      "restorative-skincomplex",

    "alastin-regenerating-skin-nectar":
      "regenerating-skin-nectar",

    "alastin-inhance-post-injection-serum":
      "inhance-post-injection-serum",

    "alastin-transform-body-treatment":
      "transform-body-treatment",

    "alastin-injection-duo-kit":
      "injection-duo-kit",


    // ==========================================================
    // FACE REALITY
    // ==========================================================

    "face-reality-ultra-gentle-gel-cleanser":
      "face-reality-ultra-gentle-gel-cleanser",

    "face-reality-barrier-balance-creamy-cleanser":
      "barrier-balance-creamy-cleanser",

    "face-reality-hydrabalance-gel":
      "hydrabalance-gel",

    "face-reality-hydraremedy-gel-serum":
      "hydraremedy-gel-serum",

    "face-reality-clearderma-moisturizer":
      "clearderma",

    "face-reality-cran-peptide-cream":
      "cran-peptide-cream",

    "face-reality-barrier-care-gel-cream":
      "barrier-care-gel-cream",

    "face-reality-soothing-radiance-toner":
      "soothing-radiance-toner",

    "face-reality-moisture-balance-toner":
      "moisture-balance-toner",

    "face-reality-sal-c-toner":
      "sal-c-toner",

    "face-reality-5-l-mandelic-serum":
      "5-l-mandelic-serum",

    "face-reality-8-l-mandelic-serum":
      "8-l-mandelic-serum",

    "face-reality-11-l-mandelic-serum":
      "11-l-mandelic-serum",

    "face-reality-salicylic-plus-serum":
      "salicylic-serum",

    "face-reality-sulfur-spot-treatment":
      "sulfur-spot-treatment",

    "face-reality-antioxidant-peptide-face-serum":
      "antioxidant-peptide-serum",

    "face-reality-glowtone-corrective-serum":
      "glowtone™-corrective-serum",


    // ==========================================================
    // COLORESCIENCE
    // ==========================================================

    "colorescience-face-shield-flex-spf-50":
      "sunforgettable-total-protection-face-shield-flex",

    "colorescience-face-shield-classic-spf-50":
      "sunforgettable-total-protection-face-shield-classic",

    "colorescience-face-shield-glow-spf-50":
      "sunforgettable-total-protection-face-shield-glow",

    // MANUAL OVERRIDE:
    // Fuzzy audit incorrectly preferred Classic.
    "colorescience-face-shield-bronze-spf-50":
      "sunforgettable-total-protection-face-shield-bronze",

    "colorescience-brush-on-shield-spf-50":
      "sunforgettable-total-protection-brush-on-sunscreen-spf-50"
  };


  window.RISE_SKIN_COMMERCE_MAP = COMMERCE_MAP;


  // ============================================================
  // LOAD LIVE SHOPIFY CATALOG
  // ============================================================

  async function fetchShopifyCatalog() {
    const products = [];
    let page = 1;

    while (true) {
      const response = await fetch(
        `/products.json?limit=250&page=${page}`,
        {
          credentials: "same-origin"
        }
      );

      if (!response.ok) {
        throw new Error(
          `Shopify catalog request failed: ${response.status}`
        );
      }

      const data = await response.json();
      const batch = data.products || [];

      if (!batch.length) {
        break;
      }

      products.push(...batch);

      if (batch.length < 250) {
        break;
      }

      page++;
    }

    return products;
  }


  // ============================================================
  // APPLY COMMERCE MAP
  // ============================================================

  async function applyCommerceMap() {
    const conciergeProducts =
      window.RISE_SKIN?.getProducts?.() ||
      window.RISE_SKIN_PRODUCTS ||
      [];

    const shopifyProducts =
      await fetchShopifyCatalog();

    const shopifyByHandle = new Map(
      shopifyProducts.map((product) => [
        product.handle,
        product
      ])
    );

    const mapped = [];
    const missingMap = [];
    const missingShopifyProduct = [];
    const missingVariant = [];

    conciergeProducts.forEach((product) => {
      const handle = COMMERCE_MAP[product.id];

      if (!handle) {
        missingMap.push({
          id: product.id,
          name: product.name,
          brand: product.brand
        });

        return;
      }

      const shopifyProduct =
        shopifyByHandle.get(handle);

      if (!shopifyProduct) {
        missingShopifyProduct.push({
          id: product.id,
          name: product.name,
          handle
        });

        return;
      }

      const variants =
  Array.isArray(
    shopifyProduct.variants
  )
    ? shopifyProduct.variants
    : [];

const optionNames =
  Array.isArray(shopifyProduct.options)
    ? shopifyProduct.options.map(
        option =>
          String(
            option?.name || option
          ).toLowerCase()
      )
    : [];

const requiresVariantSelection =
  optionNames.some(
    name =>
      name.includes("shade") ||
      name.includes("color") ||
      name.includes("colour")
  );

const defaultVariant =
  requiresVariantSelection
    ? null
    : (
        variants.find(
          variant =>
            Boolean(variant.available)
        ) ||
        variants[0] ||
        null
      );

const variantId =
  defaultVariant?.id || null;

      product.commerce = {
        ...(product.commerce || {}),

        route: "shopify",

        productHandle:
          shopifyProduct.handle,

        productId:
          shopifyProduct.id,

        variantId:
          variantId,

        requiresVariantSelection:
            requiresVariantSelection,
      };

      if (
  !variantId &&
  !requiresVariantSelection
) {
        missingVariant.push({
          id: product.id,
          name: product.name,
          handle
        });
      }

      mapped.push({
        conciergeId: product.id,
        conciergeProduct: product.name,
        brand: product.brand,

        handle:
          shopifyProduct.handle,

        productId:
          shopifyProduct.id,

        variantId:
          variantId,

        shopifyTitle:
          shopifyProduct.title
      });
    });


    const report = {
      conciergeProducts:
        conciergeProducts.length,

      mapEntries:
        Object.keys(COMMERCE_MAP).length,

      shopifyProducts:
        shopifyProducts.length,

      mapped:
        mapped.length,

      missingMap,
      missingShopifyProduct,
      missingVariant,

      valid:
        missingMap.length === 0 &&
        missingShopifyProduct.length === 0 &&
        missingVariant.length === 0
    };


    window.RISE_SKIN_COMMERCE_REPORT =
      report;

    window.RISE_SKIN_COMMERCE_PRODUCTS =
      mapped;

    window.RISE_SKIN_COMMERCE_READY =
      report.valid;


    if (window.RISE_DEBUG) {
      console.group(
        "RISE SKIN — COMMERCE MAP"
      );

      console.log(
        "Concierge products:",
        report.conciergeProducts
      );

      console.log(
        "Commerce map entries:",
        report.mapEntries
      );

      console.log(
        "Shopify products loaded:",
        report.shopifyProducts
      );

      console.log(
        "Successfully mapped:",
        report.mapped
      );

      if (missingMap.length) {
        console.error(
          "Products missing commerce mapping:",
          missingMap
        );
      }

      if (missingShopifyProduct.length) {
        console.error(
          "Mapped handles not found in Shopify:",
          missingShopifyProduct
        );
      }

      if (missingVariant.length) {
        console.error(
          "Products without usable variant:",
          missingVariant
        );
      }

      if (report.valid) {
        console.log(
          "✅ ALL CONCIERGE PRODUCTS ARE COMMERCE READY"
        );
      }

      console.groupEnd();
    }


    window.dispatchEvent(
      new CustomEvent(
        "rise:commerce-ready",
        {
          detail: report
        }
      )
    );


    return report;
  }


  window.RISE_SKIN.applyCommerceMap =
    applyCommerceMap;


  // ============================================================
  // HELPER — GET LIVE COMMERCE DATA
  // ============================================================

  window.RISE_SKIN.getCommerceProduct =
    function (productId) {

      const product =
        window.RISE_SKIN
          ?.getProductById?.(productId);

      if (!product) {
        return null;
      }

      return {
        id: product.id,
        name: product.name,
        brand: product.brand,
        commerce:
          product.commerce || null
      };
    };


  // ============================================================
  // AUTO INITIALIZE
  // ============================================================

  applyCommerceMap()
    .catch((error) => {

      window.RISE_SKIN_COMMERCE_READY =
        false;

      console.error(
        "RISE SKIN — commerce map failed",
        error
      );
    });

})();